export default __webpack_public_path__ + "static/media/box2.c31640a0.svg";